import { AccentPalette, GrayscalePalette } from '@tcl-boron-colors/colors';
import { createUseStyles } from 'react-jss';

export const useTableStyles = createUseStyles({
  container: {
    boxShadow: `0 2px 4px 0 ${GrayscalePalette[400]}`,
    width: 'fit-content',
  },
  table: {
    borderCollapse: 'collapse',
  },
  thead: {
    backgroundColor: GrayscalePalette[300],
    '& tr': {
      borderBottom: '1px solid',
      borderBottomColor: GrayscalePalette[400],
    },
  },
  th: {
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '1px',
    lineHeight: '14px',
    padding: '19px 15px',
    textAlign: 'left',
    textTransform: 'uppercase',
    verticalAlign: 'middle',
  },
  tr: {
    borderBottom: '1px solid',
    borderBottomColor: GrayscalePalette[400],
    cursor: 'pointer',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: GrayscalePalette[200],
    },
  },
  linkedRow: {
    position: 'relative',
  },
  rowLink: {
    inset: 0,
    position: 'absolute',
    zIndex: 1,
    '&::after': {
      content: '""',
      inset: 0,
      position: 'absolute',
    },
    '&:focus-visible::after': {
      outline: `2px solid ${AccentPalette[600]}`,
      outlineOffset: -2,
    },
  },
  td: {
    borderRight: '1px solid',
    borderRightColor: GrayscalePalette[250],
    fontSize: '14px',
    lineHeight: '14px',
    padding: '19px 15px',
    verticalAlign: 'middle',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  tbody: {
    backgroundColor: 'white',
  },
});

export type BoronTableClassKeys = keyof ReturnType<typeof useTableStyles>;
